import React from "react";
import axios from "axios";
import { useState } from "react";
import { baseurl } from "../../constant";
export const PayoutApiDocument = () => {
  const [data, setdats] = useState();
  const [url, setUrl] = useState();

  const token = localStorage.getItem("authToken");

  const submitCallbackurl = async () => {
    const result = await axios.post(baseurl + "callbackUpdateAuth", {
      token: token,
      type: 4,
      url: url,
    });
    setdats(result.data);
  };

  return (
    <div>
      <div className="card shadow mb-4">
        <form
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        />
        <input type="hidden" name="method" value="post" />
        <div className="card-header py-3">
          {data && (
            <h4
              style={{
                backgroundColor: "#d2f4e8",
                borderColor: "#bff0de",
                color: "green",
              }}
            >
              {data.message}
            </h4>
          )}
          <div className="row">
            <div className="col-sm-8">
              <h4>
                <b>Payout API Document</b>
              </h4>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-sm-12">
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="rechargeAPI-tab"
                    data-toggle="tab"
                    href="#rechargeAPI"
                    role="tab"
                    aria-controls="rechargeAPI"
                    aria-selected="true"
                  >
                    Payout API
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="callBack-tab"
                    data-toggle="tab"
                    href="#callBack"
                    role="tab"
                    aria-controls="callBack"
                    aria-selected="false"
                  >
                    Call Back URL
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="checkStatus-tab"
                    data-toggle="tab"
                    href="#checkStatus"
                    role="tab"
                    aria-controls="checkStatus"
                    aria-selected="true"
                  >
                    Status Check API
                  </a>
                </li>
              </ul>
              <div className="tab-content apidoc" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="rechargeAPI"
                  role="tabpanel"
                  aria-labelledby="rechargeAPI-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/transferAuth
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>Memberid</td>
                          <td>Your account unique id.</td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>Txnpwd</td>
                          <td>Your account trasaction password.</td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        {/* <!-- <tr>
                                           <td>1.</td>
                                           <td>mobile</td>
                                           <td>Customer Mobile No.</td>
                                         </tr> --> */}
                        <tr>
                          <td>1.</td>
                          <td>account_holder_name</td>
                          <td>Account Holder Name</td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>account_no</td>
                          <td>Customer Account No.</td>
                        </tr>
                        <tr>
                          <td>3.</td>
                          <td>ifsc</td>
                          <td>Customer Bank IFSC Code.</td>
                        </tr>
                        <tr>
                          <td>4.</td>
                          <td>amount</td>
                          <td>Transfer Amount</td>
                        </tr>
                        <tr>
                          <td>5.</td>
                          <td>txnID</td>
                          <td>Unique Trasaction ID(Min Length 10 )</td>
                        </tr>
                        <tr>
                          <td>6.</td>
                          <td>response_type</td>
                          <td>
                            1 for JSON, 2 for XML. Default Response Will be in
                            JSON Format
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}
                      <br />
                      "status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "status": "SUCCESS",
                      <br />
                      "txn_amount" : 100,
                      <br />
                      "txnid": 16131198309337,
                      <br />
                      "rrn" : 302111739646,
                      <br />
                      "orderID":1221108115222TYNUH,
                      <br />
                      "opt_msg" : "Transaction Successful"
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>XML Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      &lt;?xml version="1.0"?&gt; &lt;response&gt;
                      <br />
                      &lt;status_code&gt;200&lt;/status_code&gt;
                      <br />
                      &lt;status_msg&gt;OK&lt;/status_msg&gt;
                      <br />
                      &lt;status&gt;FAILED&lt;/status&gt;
                      <br />
                      &lt;txnid&gt;1234567890&lt;/txnid&gt;
                      <br />
                      &lt;optxid&gt;1234567890&lt;/optxid&gt; &lt;/response&gt;
                      <br />
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>status_code</td>
                          <td>
                            400 = Variable Related Error <br />
                            401 = Variable Data Related Error <br />
                            200 = Success
                          </td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>status_msg</td>
                          <td>
                            API Success or Error Message according status code.
                          </td>
                        </tr>
                        <tr>
                          <td>3.</td>
                          <td>status</td>
                          <td>
                            PENDING <br />
                            FAILED <br />
                            SUCCESS
                          </td>
                        </tr>
                        <tr>
                          <td>4.</td>
                          <td>txnid</td>
                          <td>Your Unique Trasaction ID.</td>
                        </tr>
                        <tr>
                          <td>5.</td>
                          <td>optxid</td>
                          <td>Unique Trasaction ID from Operator Side.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="callBack"
                  role="tabpanel"
                  aria-labelledby="callBack-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Update Callback URL</h1>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="call_back_url"
                        placeholder="Enter Callback URL"
                        onChange={(e) => {
                          setUrl(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={submitCallbackurl}
                      >
                        Save
                      </button>
                    </div>
                    <hr />
                    <p>
                      <b>Request Method - POST Json Format</b>
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    {"{"}
                    <br />
                    "status":"SUCCESS",
                    <br />
                    "txnID":"123456454",
                    <br />
                    "BankRRN":"123564654564"
                    <br />
                    {"}"}
                  </div>
                </div>

                <div
                  className="tab-pane fade show active"
                  id="checkStatus"
                  role="tabpanel"
                  aria-labelledby="checkStatus-tab"
                >
                  <div className="col-sm-12">
                    <br />
                    <h1>Request API URL</h1>
                    <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                      https://www.payol.in/portal/api/payoutCheckStatus
                    </p>
                    <hr />
                    <p>
                      <b>Request Method - POST</b>
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Header Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>Memberid</td>
                          <td>Your account unique id.</td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>Txnpwd</td>
                          <td>Your account trasaction password.</td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>
                  <div className="col-sm-12">
                    <br />
                    <h1>Post Parameter</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        {/* <!-- <tr>
                                           <td>1.</td>
                                           <td>mobile</td>
                                           <td>Customer Mobile No.</td>
                                         </tr> --> */}
                        <tr>
                          <td>1.</td>
                          <td>txnID</td>
                          <td>Your Unique Transcation ID</td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ color: "red" }}>
                      Note:- All Parameter key are case sensitive.
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>JSON Response</h1>
                    <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                      {"{"}
                      <br />
                      "status_code": 200,
                      <br />
                      "status_msg": "OK",
                      <br />
                      "status": "SUCCESS",
                      <br />
                      "amount" : 100,
                      <br />
                      "txnid": 16131198309337,
                      <br />
                      "rrn" : 302111739646,
                      <br />
                      "opt_msg" : "Transaction Fetch Successfully"
                      <br />
                      {"}"}
                    </p>
                  </div>

                  <div className="col-sm-12">
                    <br />
                    <h1>Response Parameters</h1>
                    <table className="table table-bordered table-striped">
                      <tbody>
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>status_code</td>
                          <td>
                            400 = Variable Related Error <br />
                            401 = Variable Data Related Error <br />
                            200 = Success
                          </td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>status_msg</td>
                          <td>
                            API Success or Error Message according status code.
                          </td>
                        </tr>
                        <tr>
                          <td>3.</td>
                          <td>status</td>
                          <td>
                            PENDING <br />
                            FAILED <br />
                            SUCCESS
                          </td>
                        </tr>
                        <tr>
                          <td>4.</td>
                          <td>txnid</td>
                          <td>Your Unique Trasaction ID.</td>
                        </tr>
                        <tr>
                          <td>5.</td>
                          <td>rrn</td>
                          <td>rrn no from bank side.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PayoutApiDocument;
